export default function runtimeConfig(name) {
    return window.config && window.config[name] ? window.config[name] : process.env[name];
  }
  